import { type ComponentProps, useState } from "react";

import { showLatestCitations } from "@styled/citations_to_check";

import { type DraftingInPane } from "./assistant_pane";
import { type AssistantToolbar } from "./assistant_toolbar";
import { type useDraftSections } from "./use_draft_sections";

// On Drafting, the toolbar's Sections toggle and citations count, and what the pane shows: his sections on
// a new chat or while he edits his template, else the chat, until he switches. The count shows the latest
// Citations to check, closing his sections first, and asks nothing.
export const useDraftingPane = ({
  drafting,
  chatId,
  editingTemplate,
  draftSections,
  reading,
  onShowReport,
}: {
  drafting: boolean;
  chatId: string | null;
  editingTemplate: boolean;
  draftSections: ReturnType<typeof useDraftSections>;
  reading: boolean;
  onShowReport(): void;
}) => {
  const [choice, setChoice] = useState<{
    chatId: string | null;
    open: boolean;
  } | null>(null);
  if (!drafting) return { toolbar: undefined, pane: undefined };

  const open =
    editingTemplate ||
    (choice?.chatId === chatId ? choice.open : chatId === null);
  const setOpen = (next: boolean) => setChoice({ chatId, open: next });
  const toolbar: ComponentProps<typeof AssistantToolbar>["sections"] = {
    open,
    count: draftSections.citationCount,
    onToggle: () => setOpen(!open),
    onShowCitations: () => {
      setOpen(false);
      requestAnimationFrame(() => showLatestCitations(document));
    },
  };
  const pane: DraftingInPane = {
    statuses: draftSections.statuses,
    draftable: draftSections.draftable,
    reading,
    sectionsOpen: open,
    onSectionsOpen: setOpen,
    onShowReport,
  };
  return { toolbar, pane };
};
